// import React from 'react'
import { shallowEqual, useSelector } from 'react-redux';
import { OneClickTrading } from '../../../api/request/dashboard/dashboard';
import toast from 'react-hot-toast';
import { amountMap } from '../../../MobileView/pages/Quotes';
import { useTranslation } from 'react-i18next';

const AskSell = ({ symbolId, digits }) => {
    const symbol = useSelector(state => state.updateSymbol.symbols?.[symbolId])
    const { accountId } = useSelector(state => state.accountSummary)
    const symbolParameterData = useSelector((state) => state?.symbol?.allSymbolParams?.[symbolId], shallowEqual);
        const amount = useSelector((state) =>
            state?.amount?.[symbolId] ?? symbolParameterData?.minimumAmountPerDeal ?? 0.01
        )
        const {t} = useTranslation()
    // const symbol = {};
    const sellPosition = async () => {
        try {
            const payload = {
                accountId: Number(accountId),
                side: 1,
                amount,
                symbolId,
                comment: "One-click trading",
            };
            const { data } = await OneClickTrading(payload);
            // toast.success(`Trade SELL created successfully!`);
            if (data?.id) {
                const tradeId = data.id;
                const symbolName = symbol?.name;
                const price = data.side === 1 ? symbol?.ask : symbol?.bid;
                const tradeSide = data.side === 1 ? "BUY" : "SELL";

                toast.success(`Trade Opened: ID #${tradeId}, ${symbolName} at ${price ? price.toFixed(symbol?.digits) : "0.00"}, ${tradeSide}, Amount: ${data.amount}`);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Trade execution error");
        }
    }
    return (
        <div className={`border ${symbol?.askColor == "up" ? "border-green" : symbol?.askColor == "down" && "border-red"} flex justify-between`} onClick={(e) => { e.stopPropagation(); }} onDoubleClick={(e) => { e.stopPropagation(); }}>
            <span className={`text-center px-2 flex items-center justify-center ${symbol?.askColor == "up" ? "green" : symbol?.askColor == "down" && "red"}`}>{symbol?.ask ? (symbol?.ask).toFixed(digits) : '0.00'}</span>
            <span className={`${symbol?.askColor == "up" ? "bgGreen" : symbol?.askColor == "down" && "bgRed"} bgbuySell text-white px-2 flex justify-center items-center cursor-pointer `} onClick={sellPosition}>{t("buy")}</span>
        </div>
    )
}

export default AskSell